var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 869,
    height: 616,
    viewBox: "0 0 869 616",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M509.76 219.13L507.1 199.61L653.4 164.31L666.41 260.72L509.76 300.15L511.57 271.97",
    fill: "#F9CDE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M536.124 371.84C570.512 364.493 596.655 350.424 594.517 340.416C592.379 330.408 562.768 328.251 528.38 335.598C493.993 342.945 467.849 357.014 469.987 367.022C472.126 377.03 501.736 379.187 536.124 371.84Z",
    fill: "#1E3340"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M530.648 346.257C565.035 338.91 591.179 324.841 589.041 314.833C586.903 304.826 557.292 302.668 522.904 310.015C488.517 317.362 462.373 331.431 464.511 341.439C466.649 351.447 496.26 353.604 530.648 346.257Z",
    fill: "#1E3340"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M589.05 314.827L464.511 341.435L469.977 367.018L594.516 340.41L589.05 314.827Z",
    fill: "#1E3340"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M434.83 350.35L466.11 340.94L472.33 368.44L386.44 398.73C380.88 400.69 374.56 398.24 372.17 392.85C371.51 391.37 371.13 389.65 371.23 387.68C371.45 383.02 374.41 378.93 378.63 376.93L434.84 350.36L434.83 350.35Z",
    fill: "#1E3340"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M346.89 100.14C346.89 100.14 354.3 26.91 384.96 13.68C384.96 13.68 390.69 7.95 384.96 0C384.96 0 390.88 2.65 390.35 13.23C390.35 13.23 397.1 2.97 406.36 4.3C406.36 4.3 395.77 11.58 399.08 13.56C402.39 15.54 473.85 27.13 502.31 96.94C502.31 96.94 474.74 110.28 453.12 115.14L351.87 130.69L346.89 100.14Z",
    fill: "#121841"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M468.8 109.75C468.8 109.75 435.4 177.36 396.41 162.06C396.41 162.06 360.15 136.4 362.48 109.75H385.55C385.55 109.75 383.08 68.2899 400.36 71.2499C417.63 74.2099 407.27 95.9299 407.27 95.9299C407.27 95.9299 434.58 92.9699 468.8 109.75Z",
    fill: "#F49460"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M487.75 238.09C487.75 238.09 530.39 207.14 525.47 224.33C521.53 238.09 512.24 245.51 512.24 245.51L511.58 282.57C511.58 282.57 499.49 291.17 482.05 282.57L487.76 238.1L487.75 238.09Z",
    fill: "#31C6A8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M387.47 190.21L411.73 240.24L487.75 238.08L481.43 287.26L408.56 296.89L340.84 261.67L333.6 109.92C333.6 109.92 366.8 147.6 387.46 190.21H387.47Z",
    fill: "#FFC258"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M415.4 337.16C415.4 337.16 444.07 326.57 457.75 369.36C463.32 386.79 439.81 395.36 409.99 399.4C409.99 399.4 393.78 398.68 384.96 367.7L415.4 337.16Z",
    fill: "#31C6A8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M214.48 233.59L212.03 242.57C212.74 239.25 213.55 236.23 214.48 233.59Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 346.46L183.43 346.85L183.79 345.54L184.5 346.46Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M363.22 280.92C379.69 180.34 336.65 113.29 336.65 113.29L333.57 110.2C138.19 82.41 37.0898 251.81 37.0898 251.81C37.0898 251.81 -4.84023 318.64 2.54977 441.72C2.54977 441.72 31.6598 469.59 160.97 455.73V473.49L226.89 476.13L249.59 362.38C245.42 332.58 231.36 324.76 231.36 324.76L263.75 283.36C268.83 299.72 279.85 313.89 295.01 322.84L384.29 375.56C409.22 355.71 428.83 333.19 428.83 333.19L363.22 280.92Z",
    fill: "#FFC258"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.76 459.59L0 579.1L150.89 489.15C157.21 485.38 161.08 478.55 161.04 471.19L160.98 455.74C160.98 455.74 103.94 461.28 94.76 459.6V459.59Z",
    fill: "#31C6A8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M192.13 421.17C192.13 421.17 179.03 326.32 211.29 321.47C243.56 316.62 337.12 390.73 337.12 390.73C337.12 390.73 348.26 413.23 292.91 579.1L291.31 574.27C278.01 534.16 270.41 492.39 268.71 450.18L192.13 421.18V421.17Z",
    fill: "#31C6A8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M284.28 550.99L341.51 579.1H292.91C288.9 571.2 286.15 562.72 284.76 553.97L284.29 551L284.28 550.99Z",
    fill: "#121841"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.78 559.2L48.6 579.1H0L15.78 559.2Z",
    fill: "#121841"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M333.61 110.36L348.02 95.3601C348.02 95.3601 421.38 148.3 392.26 186.24L403.73 199.47L392.7 216.1L393.58 200.79L366.18 216.1C366.18 216.1 382.55 191.08 375.27 181.38L366.18 182.26L333.6 110.35L333.61 110.36Z",
    fill: "#31C6A8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M351.87 150.66C351.87 150.66 370.19 203.41 363.23 280.93L428.84 333.2",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M231.36 324.76C231.36 324.76 192.14 301.86 190.12 366.37C188.11 430.34 195.34 446.66 195.34 446.66C195.34 446.66 127.85 472.42 15.8701 450.17",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M529.562 338.726C554.298 333.441 573.104 323.32 571.566 316.121C570.027 308.921 548.728 307.369 523.991 312.654C499.255 317.939 480.449 328.06 481.987 335.259C483.525 342.459 504.825 344.011 529.562 338.726Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M543.72 247.6C543.86 254.95 543.66 263.31 542.9 272.63",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M554.19 205.59C554.19 205.59 561.43 228.05 558.12 268.45",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M569.42 201.42C569.42 201.42 576.66 223.88 573.35 264.28",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M584.65 197.25C584.65 197.25 591.89 219.71 588.58 260.11",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M599.88 193.08C599.88 193.08 607.12 215.54 603.81 255.94",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M615.11 188.91C615.11 188.91 622.35 211.37 619.04 251.77",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M630.34 184.74C630.34 184.74 637.58 207.2 634.27 247.6",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M407.27 540.49L509.31 585.47L661.31 554.21L555 512.48L407.27 540.49Z",
    fill: "#F9CDE1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M353.32 482.97L455.37 527.95L622.18 493.64L503.45 455.73L353.32 482.97Z",
    fill: "#F9CDE1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M599.88 570.23L701.92 615.21L868.73 580.9L750.01 542.99L599.88 570.23Z",
    fill: "#F9CDE1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M260.49 207.9C260.49 207.9 251.08 274.9 273.4 302.93",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M457.09 125.43L447.13 155.73L432.58 150.66L457.09 125.43Z",
    fill: "#F49460"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M447.247 126.939C448.841 124.671 449.328 122.266 448.334 121.567C447.34 120.869 445.241 122.141 443.647 124.409C442.053 126.678 441.567 129.083 442.561 129.781C443.555 130.48 445.653 129.208 447.247 126.939Z",
    fill: "#121841"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M450.217 131.516C454.984 124.733 456.438 117.541 453.464 115.452C450.491 113.362 444.217 117.166 439.45 123.949C434.683 130.731 433.23 137.923 436.203 140.013C439.176 142.102 445.45 138.298 450.217 131.516Z",
    stroke: "#121841",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M449.72 132.2C449.72 132.2 453.65 128.55 455.25 131.06",
    stroke: "#121841",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M443.52 119.19L409.73 92.1101",
    stroke: "#121841",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M400.07 77.75C400.07 77.75 408.11 81.58 401.22 96.13",
    stroke: "#121841",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M403.73 86.9399C403.73 86.9399 396.52 87.8799 394.79 95.3599",
    stroke: "#121841",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M385.09 96.1299C385.09 96.1299 387.13 112.79 399.26 107.81",
    stroke: "#121841",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M412.7 150.66C412.7 150.66 418.51 152.19 416.21 157.94",
    stroke: "#121841",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/NoResults.e33f0be0c5fb63bdeca0cc3a27ceea93.svg";
export { ForwardRef as ReactComponent };